<template>
    <div>
        <div class="wrapper-footer">
            <div class="box-information">
                <div class="box-item">
                    <div class="ic-footer"><img src="../../../assets/new/icon/ic-footer-delivery.png" /></div>
                    <div class="text-price_desc" v-html="lbl.footer.fast_delivery"></div>
                </div>
                <div class="box-item">
                    <div class="ic-footer"><img src="../../../assets/new/icon/ic-footer-tracking.png" /></div>
                    <div class="text-price_desc" v-html="lbl.footer.tracking"></div>
                </div>
                <div class="box-item">
                    <div class="ic-footer"><img src="../../../assets/new/icon/ic-footer-paid.png" /></div>
                    <div class="text-price_desc" v-html="lbl.footer.safe_payment"></div>
                </div>
                <div class="box-item">
                    <div class="ic-footer"><img src="../../../assets/new/icon/ic-footer-warranty.png" /></div>
                    <div class="text-price_desc" v-html="lbl.footer.warranty"></div>
                </div>
            </div>
            <div class="line"></div>
            <div class="box-information2">
                <div class="box-item">
                    <div class="label">
                        {{ lbl.footer.payment_method }}
                    </div>
                    <div class="img">
                        <img src="@/assets/icon/ic-footer-payment.svg" />
                        <img src="@/assets/icon/ic-footer-visa.svg" />
                        <img src="@/assets/icon/ic-footer-mastercard.svg" />
                    </div>
                </div>
                <div class="box-item">
                    <div class="label">
                        {{ lbl.footer.delivery_service }}
                    </div>
                    <div class="img-delivery">
                        <img src="@/assets/icon/ic-jt.svg" />
                        <img src="@/assets/icon/ic-dhl.svg" />
                        <img src="@/assets/icon/ic-ninja-van.svg" /><br>
                        <img src="@/assets/icon/ic-flash.png" />
                        <img src="@/assets/icon/ic-orange-express.png" />
                    </div>
                </div>
                <div class="box-item">
                    <div class="label">
                        {{ lbl.footer.power_by }}
                    </div>
                    <div class="img">
                        <img src="@/assets/bzbslogo/bzbs-logo.svg" />
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="box-information3">
                <div class="box-item">
                    <div class="label">
                        {{ lbl.footer.shopdd.title }}
                    </div>
                    <div class="text-price_desc">
                        <div>{{ lbl.footer.shopdd.contact }}</div>
                        <div>{{ lbl.footer.shopdd.tracking }}</div>
                        <div>{{ lbl.footer.shopdd.faq }}</div>
                        <div>{{ lbl.footer.shopdd.news }}</div>
                    </div>
                </div>
                <div class="box-item policy">
                    <div class="label">
                        {{ lbl.footer.policy.title }}
                    </div>
                    <div class="text-price_desc">
                        <div>{{ lbl.footer.policy.condition }}</div>
                        <div>{{ lbl.footer.policy.privacy }}</div>
                        <div>{{ lbl.footer.policy.cookie }}</div>
                    </div>
                </div>
                <div class="box-item">
                    <div class="label">
                        {{ lbl.footer.customer.title }}
                    </div>
                    <div class="text-price_desc">
                        <div>{{ lbl.footer.customer.office_hour }}</div>
                        <div>{{ lbl.footer.customer.tel }}</div>
                        <div>
                            {{ lbl.footer.customer.email_label }}
                            <span>{{ lbl.footer.customer.email }}</span>
                        </div>
                        <div class="copyright">{{ lbl.footer.customer.market_copyright }}</div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="shop-detail" v-html="lbl.footer.shop_detail"></div>
        </div>
        <div class="wrapper-copyright">{{ lbl.footer.copyright }}</div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'Footer',
    mixins: [LocaleMixin],
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "./Footer.scss";
</style>
